import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CMSService } from '../../../services/cms-service';
import { BC } from 'model/modal-cms/bc';
import { BC_detail } from 'model/modal-cms/detail_bc';
import { AdminService } from '../../../services/admin';

@Component({
  selector: 'app-detail-bc',
  templateUrl: './detail-bc.component.html',
  styleUrls: ['./detail-bc.component.scss']
})
export class DetailBcComponent implements OnInit {
  id_bc: any;
  etat_bc_actuel: string;
  mode_bc: number = 1;
  data_bc: any;
  code: string = "ABCDEFghojklm123456789";

  constructor(public activatedRoute: ActivatedRoute,private router: Router, public adminService: AdminService, public cmsService: CMSService) { 
    this.id_bc = activatedRoute.snapshot.params['id']; }
    _bc: BC = new BC(null);
    _BC_detail: BC_detail = new BC_detail(null);
    informationAgentDRHA : any;

  ngOnInit() {
    this.getInfoBC();   
  }


  getInfoBC(){
    this.cmsService.getInfoBc(this.id_bc)
      .subscribe(data => { 
       console.log(data);           
       this._bc = data;      
       this.etat_bc_actuel =  this._bc.etat_bc; 
       if( this.etat_bc_actuel == "R"){
         this.mode_bc= 2;
         this.findOnNumBC();
       }else if( this.etat_bc_actuel == "U"){
         this.mode_bc= 3;
        // this.findOnNumBC();
       }else{
        this.mode_bc= 1;
        this.list_num_bc();
       }
        //get info drha
       this.adminService.getlisteWSDrh2(this._bc.im, this.code)
      .subscribe(data => {
        this.informationAgentDRHA = data;
        console.log("informationAgentDRHA" + data);
      }, err => {
        console.log(err);
      });
      },
        err => {
          console.log(err);
        })
    }

   


    list_num_bc(){      
      this.cmsService.getNumBC(this.id_bc)
      .subscribe(data => { 
      this.data_bc= data
      },
        err => {
          console.log(err);
        })
    }


    findOnNumBC(){
      this.cmsService.getInfoNumBcbyBcId(this.id_bc)
        .subscribe(data => {           
         this._BC_detail = data;            
        },
          err => {
            console.log(err);
          })
      }

}
